import { api, ERR_OK } from './config';
import axios from 'axios';

/**
 * 获取教练列表
 * @param userId
 * @param pageIndex
 * @param no
 * @param name
 * @param phoneNo
 * @return {Promise<AxiosResponse<any>>}
 */
export async function getCoachList(userId, pageIndex, no = '', name = '', phoneNo = '') {
  return await axios.post(api.coachListUrl, {
    userId,
    pageIndex,
    no,
    name,
    phoneNo
  }).then((res) => {
    if (res.data.rspCode === ERR_OK) {
      return res.data;
    } else {
      return [];
    }
  });
}

/**
 * 教练工具(新增和修改)
 * @param coach
 * @param types
 * @return {Promise<void>}
 */
export async function coachUtil(coach, types) {
  const {
    userId,
    uuid,
    no,
    phoneNo,
    name,
    nameEnglish,
    disclosureDue,
    firstAidDue,
    memberFeeDue,
    qualifications1,
    cpdDue1,
    qualifications2,
    cpdDue2,
    qualifications3,
    cpdDue3,
    isBlack
  } = coach;
  switch (types) {
    case 1:
      return await axios.post(api.coachUrl, {
        userId,
        no,
        phoneNo,
        name,
        nameEnglish,
        disclosureDue,
        firstAidDue,
        memberFeeDue,
        qualifications1,
        cpdDue1,
        qualifications2,
        cpdDue2,
        qualifications3,
        cpdDue3,
        isBlack
      }).then((res) => {
        return res.data;
      });
    case 2:
      return await axios.put(api.coachUrl, {
        userId,
        uuid,
        no,
        phoneNo,
        name,
        nameEnglish,
        disclosureDue,
        firstAidDue,
        memberFeeDue,
        qualifications1,
        cpdDue1,
        qualifications2,
        cpdDue2,
        qualifications3,
        cpdDue3,
        isBlack
      }).then((res) => {
        return res.data;
      });
  }
}

/**
 * 批量导入
 * @param userId
 * @param batchNo
 * @return {Promise<AxiosResponse<any>>}
 */
export async function addCoaches(userId, batchNo) {
  return await axios.post(api.saveCoachesUrl, {
    userId,
    batchNo
  }).then((res) => {
    return res.data;
  });
}